/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Discounts_DescriptionInputs */

const en_admin_resource_form_discounts_description = /** @type {(inputs: Admin_Resource_Form_Discounts_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make longer bookings more attractive`)
};

const de_admin_resource_form_discounts_description = /** @type {(inputs: Admin_Resource_Form_Discounts_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Längere Buchungen attraktiver machen durch Rabatte`)
};

const es_admin_resource_form_discounts_description = /** @type {(inputs: Admin_Resource_Form_Discounts_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz más atractivas las reservas de larga duración`)
};

const fr_admin_resource_form_discounts_description = /** @type {(inputs: Admin_Resource_Form_Discounts_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendez les réservations de longue durée plus attrayantes`)
};

/** @type {(inputs: Admin_Resource_Form_Discounts_DescriptionInputs) => LocalizedString} */
const it_admin_resource_form_discounts_description = en_admin_resource_form_discounts_description;

/** @type {(inputs: Admin_Resource_Form_Discounts_DescriptionInputs) => LocalizedString} */
const pt_br2_admin_resource_form_discounts_description = en_admin_resource_form_discounts_description;

/** @type {(inputs: Admin_Resource_Form_Discounts_DescriptionInputs) => LocalizedString} */
const pl_admin_resource_form_discounts_description = en_admin_resource_form_discounts_description;

/** @type {(inputs: Admin_Resource_Form_Discounts_DescriptionInputs) => LocalizedString} */
const hu_admin_resource_form_discounts_description = en_admin_resource_form_discounts_description;

/** @type {(inputs: Admin_Resource_Form_Discounts_DescriptionInputs) => LocalizedString} */
const ro_admin_resource_form_discounts_description = en_admin_resource_form_discounts_description;

/**
* | output |
* | --- |
* | "Make longer bookings more attractive" |
*
* @param {Admin_Resource_Form_Discounts_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_discounts_description = /** @type {((inputs?: Admin_Resource_Form_Discounts_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Discounts_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_discounts_description(inputs)
	if (locale === "de") return de_admin_resource_form_discounts_description(inputs)
	if (locale === "es") return es_admin_resource_form_discounts_description(inputs)
	if (locale === "fr") return fr_admin_resource_form_discounts_description(inputs)
	if (locale === "it") return it_admin_resource_form_discounts_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_discounts_description(inputs)
	if (locale === "pl") return pl_admin_resource_form_discounts_description(inputs)
	if (locale === "hu") return hu_admin_resource_form_discounts_description(inputs)
	return ro_admin_resource_form_discounts_description(inputs)
});
export { admin_resource_form_discounts_description as "admin.resource_form.discounts_description" }